/* VENDURON Shop — Reveals + Counter (defer) */
(function(){
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (rm) { document.documentElement.classList.add('vd-rm'); }
  /* Scroll-Reveals */
  var els = [].slice.call(document.querySelectorAll('.vr'));
  if (rm || !('IntersectionObserver' in window)) {
    els.forEach(function(e){ e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.18, rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  /* Counter */
  var cs = [].slice.call(document.querySelectorAll('[data-count]'));
  if (!cs.length) return;
  function run(el){
    var end = parseFloat(el.getAttribute('data-count'));
    var suf = el.getAttribute('data-suffix') || '';
    if (rm) { el.textContent = end + suf; return; }
    var t0 = null, dur = 1100;
    function step(t){
      if(!t0) t0 = t;
      var p = Math.min((t - t0)/dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * p) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if (rm || !('IntersectionObserver' in window)) { cs.forEach(run); return; }
  var cio = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ run(e.target); cio.unobserve(e.target); } });
  }, {threshold:.5});
  cs.forEach(function(c){ cio.observe(c); });
})();

/* Header-CTA: Probebox-Button in die rechte Header-Spalte */
(function(){
  try {
    var right = document.querySelector('header-component .header__column--right');
    if (!right || document.querySelector('.vd-hcta')) return;
    var a = document.createElement('a');
    a.className = 'vd-hcta';
    a.href = '/products/probebox';
    a.textContent = 'Probebox · 250 €';
    right.insertBefore(a, right.firstChild);
  } catch(e){}
})();

/* Hover-Crossfade: Design-Bild -> echtes Pack-Foto (2. Medium) */
(function () {
  function init() {
    document.querySelectorAll('.product-grid__item .card-gallery, product-recommendations .card-gallery, .product-list .card-gallery').forEach(function (gal) {
      if (gal.dataset.vdHover) return;
      var slides = gal.querySelectorAll('slideshow-slide img, .product-media img');
      if (slides.length < 2) return;
      gal.dataset.vdHover = '1';
      var ov = document.createElement('img');
      ov.className = 'vd-hoverimg';
      ov.src = slides[1].currentSrc || slides[1].src;
      if (slides[1].srcset) ov.srcset = slides[1].srcset;
      ov.sizes = slides[1].sizes || '';
      ov.alt = '';
      ov.setAttribute('aria-hidden', 'true');
      ov.loading = 'lazy';
      gal.style.position = 'relative';
      gal.appendChild(ov);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
})();

/* Mobil: echte Header-Höhe messen, damit der Inhalt exakt darunter startet */
(function () {
  function setH() {
    if (window.innerWidth > 749) { document.documentElement.style.removeProperty('--vd-header-h'); return; }
    var g = document.querySelector('#header-group');
    if (g) document.documentElement.style.setProperty('--vd-header-h', Math.round(g.getBoundingClientRect().height) + 'px');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setH); else setH();
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);
  setTimeout(setH, 1200);
})();
